<template>
  <div class="full-height">
    <div
      width="100%"
      rounded="0"
      class="full-height"
      :class="!isMobile ? 'd-flex flex-column mx-5' : 'mx-1'"
    >
      <Header
        title="People and Groups"
        icon="mdi-account-multiple"
        iconColor="brand"
        :elevation="1"
        :showSearch="false"
      />
      <v-row class="pt-8">
        <v-col cols="12" sm="12" md="3">
          <v-card class="pa-3 pt-12 rounded-lg d-flex flex-column align-end" :elevation="1">
            <div class="d-flex align-center mb-2 font-weight-bold">
              <Typography class="mr-3 mb-1" variant="body-2">
                <strong>
                  <slot name="selected-count"></slot>
                </strong>
              </Typography>
              <Button
                small
                color="lightGrey"
                class="black--text"
                @click="clearSelected"
                v-if="selectedLength > 0"
              >
                Clear
              </Button>
            </div>
            <slot name="actions"></slot>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="9">
          <v-card :elevation="1" class="rounded-lg pa-3">
            <div :class="['tabs-header', { 'flex-column': isMobile }]">
              <v-tabs :value="tab" color="brandPrimary">
                <v-tab
                  href="#people"
                  v-if="permissions.includes('vue:read:people')"
                  @click="handlePeoplePageClick"
                  >People</v-tab
                >
                <v-tab
                  href="#groups"
                  v-if="permissions.includes('vue:read:groups')"
                  @click="handleGroupsPageClick"
                  >Groups</v-tab
                >
                <v-tab
                  href="#pending"
                  v-if="
                    permissions.includes('vue:read:pendingusers') &&
                    isApprovalQueueEnabled(globalClientId)
                  "
                  @click="handlePendingPageClick"
                  >Pending&nbsp;
                  <span v-if="pendingUserCount && pendingUserCount.count !== null">
                    ({{ pendingUserCount.count }})</span
                  ></v-tab
                >
              </v-tabs>
            </div>
            <div
              class="d-flex align-center pb-3"
              :class="hasSearchRowActions ? 'justify-space-between' : 'justify-end'"
            >
              <div class="d-flex align-center">
                <slot name="search-row-actions"></slot>
              </div>
              <v-text-field
                outlined
                placeholder="Search"
                single-line
                dense
                hide-details
                v-model="debounceSearch"
                class="shrink full-width"
                append-icon="mdi-magnify"
                :style="isMobile ? '' : 'max-width: 450px;'"
                clearable
                color="brandCyan"
              ></v-text-field>
            </div>
            <slot name="data-table"></slot>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <slot name="overlay"></slot>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Button from "@/components/generic/Button.vue";
import Typography from "@/components/generic/Typography.vue";
import { debounce } from "@/shared_data/functions";
import { mapState } from "vuex";
import isApprovalQueueEnabled from "@/mixins/isApprovalQueueEnabled";

export default {
  name: "PeopleAndGroupsTemplate",
  components: {
    Header,
    Button,
    Typography,
  },
  mixins: [isApprovalQueueEnabled],
  props: {
    tab: {
      default: "people",
      type: String,
    },
    selectedLength: {
      default: 0,
      type: Number,
    },
    clearSelected: {
      type: Function,
      default: () => {},
    },
    handleSearchValueChange: {
      type: Function,
      default: () => {},
    },
  },
  mounted() {
    this.$store.dispatch("fetchPendingUserCount");
  },
  data() {
    return {
      search: null,
      debounceSearch: null,
    };
  },
  methods: {
    handlePeoplePageClick() {
      this.tab !== "people" && this.$router.push("/people");
    },
    handleGroupsPageClick() {
      this.tab !== "groups" && this.$router.push("/people/groups");
    },
    handlePendingPageClick() {
      this.tab !== "pending" && this.$router.push("/people/pending");
    },
  },
  watch: {
    debounceSearch: debounce(function (newVal) {
      this.search = newVal;
      this.$emit("update-search", newVal);
    }, 500),
    globalClientId: {
      handler() {
        console.log("globalClientId changed", this.globalClientId);
        this.$store.dispatch("setPendingUserCount", null);
        this.$store.dispatch("fetchPendingUserCount");
      },
    },
  },
  computed: {
    ...mapState(["permissions", "pendingUserCount", "globalClientId"]),
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    hasSearchRowActions() {
      return !!this.$slots["search-row-actions"];
    },
  },
};
</script>

<style scoped>
.tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  margin-bottom: 1rem;
}

.tabs-header.flex-column {
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  border-bottom: none;
}

.tabs-header.flex-column > .v-tabs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
